import React, { useState, useEffect } from "react";
import privateAxios from "../../utils/axiosPrivate";
import { Link, useNavigate } from "react-router-dom";
import { loginAsUser } from "../../locales/en";
import { useDispatch } from "react-redux";
import {
  getNavItems,
  setProfile,
  setUsersData
} from "../../redux/userManagementSlice";
import { getRevertToAdminURL } from "../../utils/constants/apiEndPoints";
import { CLIENT_DETAILS } from "../../route/paths";
import { getUserPermission } from "../../redux/roleManagementSlice";

const LoginAsUser = () => {
  const [loginAsName, setLoginAsName] = useState(null);
  const [loginAsId, setLoginAsId] = useState(null);
  const [mainUserName, setMainUserName] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Fetch admin name and loginAs name from local storage on component load
  useEffect(() => {
    const storedLoginAsName = getLoginAsUserNameFromLocalStorage();
    if (storedLoginAsName) {
      setLoginAsName(storedLoginAsName);
    }
    const storedLoginAsId = getLoginAsUserIdFromLocalStorage();
    if (storedLoginAsId) {
      setLoginAsId(storedLoginAsId);
    }
    const mainUserName = getMainUserNameFromLocalStorage();
    if (mainUserName) {
      setMainUserName(mainUserName);
    }
  }, []);

  // Trigger this function when re-logging in as admin
  const handleReLoginAsAdmin = async () => {
    try {
      const response = await privateAxios.post(getRevertToAdminURL);

      if (response.status === 200) {
        dispatch(setProfile({}));
        dispatch(setUsersData({}));
        removeLoginAsNameFromLocalStorage();
        setLoginAsName(null);
        const event = new CustomEvent("refreshHeader");
        window.dispatchEvent(event);

        await dispatch(getNavItems()).unwrap();
        dispatch(getUserPermission());

        navigate(CLIENT_DETAILS(loginAsId));
      }
    } catch {
      // handle catch here;
    }
  };

  return (
    <>
      {/* Show this message only when logged in as another user */}
      {loginAsName && (
        <div className="login_as_sec">
          <p>
            {`${loginAsUser?.text1} ${loginAsName}. `}
            <Link onClick={handleReLoginAsAdmin}>
              {loginAsUser?.text2} {mainUserName}
            </Link>
          </p>
        </div>
      )}
    </>
  );
};

export default LoginAsUser;

export const setLoginAsNameInLocalStorage = (loginUserDetails = {}) => {
  const {
    loginAsUserOriginalName,
    mainUserOriginalName,
    loginAsUserAccountId
  } = loginUserDetails;
  localStorage.setItem("_fundTapLoginAsUserName", loginAsUserOriginalName);
  localStorage.setItem("_fundTapLoginAsUserId", loginAsUserAccountId);
  localStorage.setItem("_fundTapMainUserName", mainUserOriginalName);
};

export const getLoginAsUserNameFromLocalStorage = () => {
  return localStorage.getItem("_fundTapLoginAsUserName");
};

export const getLoginAsUserIdFromLocalStorage = () => {
  return localStorage.getItem("_fundTapLoginAsUserId");
};

export const getMainUserNameFromLocalStorage = () => {
  return localStorage.getItem("_fundTapMainUserName");
};

export const removeLoginAsNameFromLocalStorage = () => {
  localStorage.removeItem("_fundTapLoginAsUserName");
  localStorage.removeItem("_fundTapLoginAsUserId");
  localStorage.removeItem("_fundTapMainUserName");
};
